import { useQuery } from 'react-query';
import { queryAllStatsCOM } from './useAllStatsCOM.query';
import { UseAllStatsCOMOptions } from './useAllStatsCOM.types';
import { AllStatsCOMResponse } from '../../../types/api/endpoints/stats/stats.types';

export const ALL_STATS_COM_QUERY_KEY = 'ALL_STATS_COM';

export const useAllStatsCOM = (options?: UseAllStatsCOMOptions) => {
  return useQuery<AllStatsCOMResponse, Error>(ALL_STATS_COM_QUERY_KEY, () => queryAllStatsCOM(), {
    ...options,
    retry: false,
    refetchOnWindowFocus: false,
  });
};
